import React, { useRef, useEffect, useState } from "react"
import { EditorState, ContentState, convertToRaw } from "draft-js"
import Loading from "./Loading"
import htmlToDraft from "html-to-draftjs"
import draftToHtml from "draftjs-to-html"
import { Editor } from "react-draft-wysiwyg"
import { useMutation } from "@apollo/client"
import { UPDATE_NOTE } from "../graphql/UpdateNote"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import { INote } from "../interface"
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai"

interface IProps {
  showEdit: boolean
  refetch: () => null
  setShowEdit: React.Dispatch<React.SetStateAction<boolean>>
  editInfo: INote | null
}

const Edit: React.FC<IProps> = ({ showEdit, setShowEdit, editInfo, refetch }) => {
  const [title, setTitle] = useState<string>("")
  const [keyword, setkeyWord] = useState<string>("")
  const [content, setContent] = useState<string>("")
  const [editorState, setEditorState] = useState<EditorState>(EditorState.createEmpty())
  const divRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    showEdit ? divRef.current?.classList.remove("translate-x-full") : divRef.current?.classList.add("translate-x-full")
    if (editInfo === null) return
    setTitle(editInfo?.title!)
    setkeyWord(editInfo?.keyword!)
    setContent(editInfo?.content!)
    const contentBlock = htmlToDraft(editInfo?.content!)
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
    setEditorState(EditorState.createWithContent(contentState))
  }, [showEdit, editInfo])

  const [updateNoteMutation, { error, loading }] = useMutation(UPDATE_NOTE)

  const updateHandle = async () => {
    await updateNoteMutation({
      variables: {
        noteId: editInfo?._id,
        title: title,
        keyword: keyword,
        content: content,
      },
    })
    setShowEdit(false)
    refetch()
  }

  if (loading) return <Loading />

  if (error) {
    console.log("ERROR!", error)
  }

  return (
    <div className='fixed inset-0 z-30 mb-40 text-xs transition-all duration-300 translate-x-full sm:text-sm sm:mb-24 overscroll-auto ' ref={divRef}>
      <div className='grid grid-rows-[auto_auto_auto_1fr] p-2 bg-slate-600 h-full min-w-full'>
        <h2 className='text-2xl text-center'>Note</h2>
        {/* Textboxes */}
        <div className='flex flex-col p-2 px-8 space-y-2'>
          <input className='p-1 px-4 border-2 rounded-sm focus:outline-slate-800 md:text-lg outline outline-1 bg-inherit border-slate-500' type='text' placeholder='Title' onChange={(e) => setTitle(e.target.value)} value={title} />
          <input className='p-1 px-4 border-2 rounded-sm outline outline-1 focus:outline-slate-800 md:text-lg bg-inherit border-slate-500' type='text' placeholder='Keywords' onChange={(e) => setkeyWord(e.target.value)} value={keyword} />
        </div>
        {/* button */}
        <div className='flex justify-end px-5 py-1 space-x-1'>
          <button
            className='w-8 h-8 grid place-content-center text-[8px] p-1 text-green-500 border-2 rounded-full bg-slate-700 border-slate-400 hover:text-green-200'
            onClick={(event) => {
              event.stopPropagation()
              updateHandle()
            }}
          >
            <AiFillCheckCircle className='text-4xl ' />
          </button>

          <button
            className='w-8 h-8  grid place-content-center text-[8px] p-1 text-red-500 border-2 rounded-full bg-slate-700 border-slate-400 hover:text-red-400'
            onClick={(event) => {
              event.stopPropagation()
              setShowEdit(false)
            }}
          >
            <AiFillCloseCircle className='text-4xl' />
          </button>
        </div>

        {/* Editor */}
        <Editor
          wrapperClassName='min-h-full rounded-md '
          toolbarClassName='text-black p-2 rounded text-xs'
          editorClassName='leading-none text-black cursor-text rounded shadow-md shadow-slate-300 p-2 bg-orange-50 md:p-4'
          placeholder='Write Your Centent Here ...'
          editorState={editorState}
          onEditorStateChange={(newState) => {
            const rawDraftjs = convertToRaw(newState.getCurrentContent())
            const convertedToHtml = draftToHtml(rawDraftjs)
            setContent(convertedToHtml)
            setEditorState(newState)
          }}
          toolbar={{
            options: ["inline", "blockType", "fontSize", "fontFamily", "list", "textAlign", "colorPicker", "link", "emoji", "image"],
          }}
        />
      </div>
    </div>
  )
}

export default Edit
